<div class="clug-list-card">
  <div class="card-loader" *ngIf="loading">
    <mat-spinner diameter="28"></mat-spinner>
  </div>

  <div class="card-header">
    <span class="card-header-count">{{totalCount}} Candidate(s)</span>
    <div class="input-group">
      <i class="bi bi-search"></i>
      <input type="text" placeholder="Search candidates..." [(ngModel)]="candidateSearch" (keyup)="searchCandidate()">
    </div>
  </div>

  <div class="table-responsive">
    <table matSort (matSortChange)="sortData($event)" class="table">
      <thead>
        <tr>
          <th mat-sort-header="name" scope="col">Name</th>
          <th mat-sort-header="email" scope="col">Email</th>
          <th mat-sort-header="employment_end_date" scope="col">Employment End Date</th>
          <th mat-sort-header="created_at" scope="col">Created At</th>
          <th mat-sort-header="action" scope="col" class="actions-col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let candidate of allCandidates; let i = index" class="dataColumn">
          <td>
            <div class="contractor-cell">
              <div class="avatar" *ngIf="candidate.profile_pic">
                <img alt="" src="{{dataSharedService.getImage(candidate.profile_pic)}}">
              </div>
              <div class="avatar" *ngIf="!candidate.profile_pic">
                <span>{{authService.getInitials(candidate.name)}}</span>
              </div>
              <span class="contractor-name">{{candidate.name}}</span>
            </div>
          </td>
          <td>{{candidate.email}}</td>
          <td *ngIf="candidate.employment_end_date">
            {{dataSharedService.getFormatedDate(candidate.employment_end_date)}}
          </td>
          <td *ngIf="!candidate.employment_end_date">--</td>
          <td>{{dataSharedService.getFormatedDate(candidate.created_at)}}</td>
          <td class="td-actions">
            <div class="row-actions">
              <button type="button" class="icon-btn-sm approve" matTooltip="Activate account" [matTooltipPosition]="'left'" (click)="activateAccount(candidate.uuid)">
                <i class="bi bi-unlock"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="card-pagination" *ngIf="totalCount">
    <span class="pagination-summary">
      Showing {{ pageStart }}–{{ pageEnd }} of {{ totalCount }} candidates
    </span>
    <app-api-paginator [totalCount]="totalCount" (onStepChange)="onStepChange($event)"></app-api-paginator>
  </div>
</div>
